import React, { useState, useEffect } from 'react'
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill,
} from 'react-icons/bs'

import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'

var _ = require('lodash')

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const options = {
  cMapUrl: 'cmaps/',
  standardFontDataUrl: 'standard_fonts/',
}

export const PoRecapForm = ({ formData, steps }) => {
  const [numPages, setNumPages] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const pdfWrapperRef = React.useRef()
  const [elementSize, setElementSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const getElementSize = () => {
      if (pdfWrapperRef.current) {
        const { width, height } = pdfWrapperRef.current.getBoundingClientRect()
        setElementSize({ width, height })
      }
    }

    getElementSize()

    const handleResize = () => {
      getElementSize()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
    setPageNumber(1)
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset)
  }

  function previousPage() {
    changePage(-1)
  }

  function nextPage() {
    changePage(1)
  }

  const getAllAValues = () => {
    let data = []

    // Log complet de formData pour débogage
    console.log('FormData complet reçu par PoRecapForm:', formData)
    console.log('Vérification spécifique G__photos:', formData['G__photos'])

    // Fonction pour vérifier si une valeur est vide ou non
    const isEmptyValue = (val) => {
      if (val === null || val === undefined || val === '') return true
      if (typeof val === 'object' && Object.keys(val).length === 0) return true
      if (Array.isArray(val) && val.length === 0) return true
      return false
    }

    // Traiter les données du formulaire
    for (var property in formData) {
      // Ignorer certaines propriétés techniques sauf si elles sont essentielles
      if (property === '_tempFiles' || property === '_serverFiles' || property === 'draft_id') continue

      const value = formData[property]

      // Traitement spécial pour les tableaux
      if (Array.isArray(value)) {
        if (value.length > 0) {
          data.push({ field: property, value: value })
        }
      }
      // Vérifier si la valeur est un objet qui contient des données
      else if (typeof value === 'object' && value !== null && !(value instanceof Date)) {
        // Cas spécial pour les objets File
        if (value instanceof File) {
          data.push({ field: property, value: value })
        } 
        // Cas pour les objets contenant des Files (comme G__photos)
        else if (Object.values(value).some(v => v instanceof File)) {
          data.push({ field: property, value: value })
        }
        // Si c'est un objet standard, traiter ses propriétés
        else {
          const hasValidData = Object.values(value).some(v => !isEmptyValue(v))
          if (hasValidData) {
            data.push({ field: property, value: value })
          }
        }
      } else if (!isEmptyValue(value)) {
        // Si c'est une valeur simple non vide, l'ajouter directement
        data.push({ field: property, value: value })
      }
    }

    // Ajouter une information si c'est un brouillon
    if (formData.draft_id) {
      console.log('Récapitulatif d\'un brouillon:', formData.draft_id)
    }

    // Trier les données par nom de champ
    const sortedData = data.sort((a, b) => {
      if (a.field < b.field) return -1
      if (a.field > b.field) return 1
      return 0
    })

    console.log('Données récapitulatives:', sortedData)
    return sortedData
  }

  const previewImage = (file) => {
    // Si le fichier est une instance de File (mode création)
    if (file instanceof File) {
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        const imageSrc = URL.createObjectURL(file)
        return <img src={imageSrc} className="max-w-full" />
      } else if (file.type === 'application/pdf') {
        return (
          <div ref={pdfWrapperRef}>
            <Document
              file={file}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
            >
              <Page
                pageNumber={pageNumber}
                width={elementSize.width || undefined}
              />
            </Document>
            <div className="flex justify-between m-4 ">
              <button
                type="button"
                disabled={pageNumber <= 1}
                onClick={previousPage}
              >
                <BsFillArrowLeftCircleFill size={30} />
              </button>
              <p>
                Page {pageNumber || (numPages ? 1 : '--')} sur {numPages || '--'}
              </p>
              <button
                type="button"
                disabled={numPages ? pageNumber >= numPages : true}
                onClick={nextPage}
              >
                <BsFillArrowRightCircleFill size={30} />
              </button>
            </div>
          </div>
        )
      } else {
        return <div className="text-gray-600">Type de fichier non pris en charge pour la prévisualisation</div>
      }
    }
    // Si le fichier est un objet avec une URL (mode brouillon)
    else if (file && typeof file === 'object' && file.url) {
      const fileUrl = file.url
      const fileType = fileUrl.toLowerCase()

      if (fileType.endsWith('.jpg') || fileType.endsWith('.jpeg') || fileType.endsWith('.png')) {
        return <img src={fileUrl} className="max-w-full" alt="Image prévisualisée" />
      } else if (fileType.endsWith('.pdf')) {
        return (
          <div ref={pdfWrapperRef}>
            <Document
              file={fileUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
            >
              <Page
                pageNumber={pageNumber}
                width={elementSize.width || undefined}
              />
            </Document>
            <div className="flex justify-between m-4 ">
              <button
                type="button"
                disabled={pageNumber <= 1}
                onClick={previousPage}
              >
                <BsFillArrowLeftCircleFill size={30} />
              </button>
              <p>
                Page {pageNumber || (numPages ? 1 : '--')} sur {numPages || '--'}
              </p>
              <button
                type="button"
                disabled={numPages ? pageNumber >= numPages : true}
                onClick={nextPage}
              >
                <BsFillArrowRightCircleFill size={30} />
              </button>
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              Télécharger le fichier
            </a>
          </div>
        )
      }
    } else {
      return <div className="text-gray-600">Fichier non disponible pour la prévisualisation</div>
    }
  }

  const renderValueField = (field, level) => {
    // Gérer les fichiers (File ou objet avec url)
    if (field.value instanceof File || (field.value && typeof field.value === 'object' && field.value.url)) {
      const isFileInstance = field.value instanceof File
      const fileName = isFileInstance
        ? field.value.name.replace(/^.*?__/, '')
        : (field.value.name || 'Fichier téléchargé')

      return (
        <div
          className={`${
            level === 0 ? 'grid grid-cols-1 md:grid-cols-6' : ' py-4'
          }`}
        >
          <p className="col-span-1">
            <span className={`${level === 0 ? 'uppercase' : 'font-bold'}`}>
              Nom du fichier :{' '}
            </span>
            {fileName}
          </p>
          <div className="col-span-5 my-4 border border-gray-200 p-4">
            {previewImage(field.value)}
          </div>
        </div>
      )
    } else if (field.value instanceof Date) {
      return (
        <div
          className={`${
            level === 0 ? 'grid grid-cols-1 md:grid-cols-6' : 'flex gap-1 py-4'
          }`}
        >
          <p className="col-span-1">
            <span className={`${level === 0 ? 'uppercase' : 'font-bold'}`}>
              Date :
            </span>
          </p>
          <div className="col-span-5">
            {new Date(field.value).toLocaleDateString('fr-FR', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            })}
          </div>
        </div>
      )
    } else if (Array.isArray(field.value)) {
      return (
        <div
          className={`${
            level === 0 ? 'grid grid-cols-1 md:grid-cols-6' : 'flex py-4'
          }`}
        >
          <p className="col-span-1">
            <span className={`${level === 0 ? 'uppercase' : ''}`}>
              {field.field.replace(/^.*?__/, '')} :
            </span>
          </p>
          <div className="col-span-5 p-4 bg-white divide-y-2">
            {field.value.map((item, index) => (
              <div key={index} className="py-2">
                {typeof item === 'object' && item !== null ? 
                  Object.entries(item).map(([key, val]) => (
                    <div key={key} className="flex gap-2 py-1">
                      <span className="font-bold">{key} :</span>
                      <span>{String(val)}</span>
                    </div>
                  ))
                : 
                  <span>{String(item)}</span>
                }
              </div>
            ))}
          </div>
        </div>
      )
    } else if (field.value instanceof Object) {
      let items = []

      for (const key in field.value) {
        //console.log(key, field.value[key])
        items.push(
          renderValueField(
            {
              field: key,
              value: field.value[key],
            },
            1
          )
        )
      }

      return (
        <div
          className={`${
            level === 0 ? 'grid grid-cols-1 md:grid-cols-6' : 'flex py-4'
          }`}
        >
          <p className="col-span-1">
            <span className={`${level === 0 ? 'uppercase' : ''}`}>
              {field.field.replace(/^.*?__/, '')} :
            </span>
          </p>
          <div className="col-span-5 p-4 bg-white divide-y-2">{items}</div>
        </div>
      )
    } else {
      const labelField = _.find(
        steps.flatMap((group) => group.fields || []), // Appartient à un groupe, donc aplati le tableau
        { name: field.field }
      )
      return (
        <div
          className={`${
            level === 0 ? 'grid grid-cols-1 md:grid-cols-6' : 'flex gap-1 py-4'
          }`}
        >
          <p className="col-span-1">
            <span className={`${level === 0 ? 'uppercase' : 'font-bold'}`}>
              {level === 0 ? (
                <>{field.field.replace(/^.*?__/, '')}</>
              ) : (
                <>{labelField?.label || field.field} : </>
              )}
            </span>
          </p>
          <div className="col-span-5">{field.value}</div>
        </div>
      )
    }
  }

  return (
    <div className="bg-gray-200 p-4 py-6 rounded-lg">
      <div className="flex gap-6 flex-col divide-y">
        {/* {JSON.stringify(getAllAValues())} */}
        {getAllAValues().map((field) => renderValueField(field, 0))}
      </div>
    </div>
  )
}
